const LS_KEY_EN = 'spellingApp_voice_en';
const LS_KEY_ZH = 'spellingApp_voice_zh';

function getStoredVoiceName(lang) {
  return localStorage.getItem(lang === 'zh' ? LS_KEY_ZH : LS_KEY_EN);
}

function findVoice(voices, storedName, langPrefix) {
  if (storedName) {
    const match = voices.find(v => v.name === storedName);
    if (match) return match;
  }
  return voices.find(v => v.lang.toLowerCase().startsWith(langPrefix)) || null;
}

export function speakText(text, lang = 'en', rate = 1.0, onEnd = null) {
  if (!window.speechSynthesis) {
    if (onEnd) setTimeout(onEnd, 300);
    return;
  }
  if (window.speechSynthesis.speaking) window.speechSynthesis.cancel();
  setTimeout(() => {
    const u = new window.SpeechSynthesisUtterance(text);
    const isZh = lang === 'zh';
    const voices = window.speechSynthesis.getVoices();
    const voice = findVoice(voices, getStoredVoiceName(lang), isZh ? 'zh' : 'en');
    if (voice) u.voice = voice;
    u.lang = isZh ? 'zh-CN' : 'en-SG';
    u.rate = rate;
    if (onEnd) u.onend = onEnd;
    window.speechSynthesis.speak(u);
  }, 100);
}

export function getAvailableVoices(lang) {
  if (!window.speechSynthesis) return [];
  const prefix = lang === 'zh' ? 'zh' : 'en';
  return window.speechSynthesis.getVoices().filter(v => v.lang.toLowerCase().startsWith(prefix));
}

export function saveVoicePreference(lang, voiceName) {
  localStorage.setItem(lang === 'zh' ? LS_KEY_ZH : LS_KEY_EN, voiceName);
}
